/**
 * Tier-1 client for the stuck-webhook queue (roadmap item I).
 *
 * Separate from `promo-admin.ts` because it is a different operator job on a
 * different table — the promo admin manages campaigns, this one triages
 * money-path failures.
 */
import { request } from '@papan/api-client'

/** A webhook event the replay sweep has given up on.
 *
 *  The raw Stripe `payload` is deliberately NOT on the wire — it is large and
 *  carries customer detail a triage list does not need. `eventId` is the handle
 *  for pulling the full object up in the Stripe dashboard. */
export interface StuckWebhookEventView {
  id: string
  eventId: string
  eventType: string
  attempts: number
  error: string | null
  receivedAt: string
  processedAt: string | null
}

export const webhookAdminApi = {
  /** The queue, plus the bound it was computed against so the UI can say
   *  "6 of 6 attempts" rather than hardcoding a number the server owns. */
  listStuck: () =>
    request<{ maxAttempts: number; truncated: boolean; events: StuckWebhookEventView[] }>(
      '/api/admin/billing/webhook-events/stuck',
    ),

  /** Hand one back to the sweep. Does not replay inline — the sweep owns
   *  ordering, batching and the bound; see the route's note. */
  retry: (id: string) =>
    request<{ requeued: boolean }>(`/api/admin/billing/webhook-events/${id}/retry`, {
      method: 'POST',
    }),
}
